import { createStore } from 'redux';

import { breadcrumb } from './reducers/breadcrumb';

const store = createStore(breadcrumb);

export default store;
